<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button type="primary" @click="editActivity">新增州</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item style="margin-right: 10px !important">
            <el-input v-model.trim="queryForm.keyword" placeholder="州名称" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="州名"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="纬度"
        prop="basic.lat"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="经度"
        prop="basic.lng"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="状态" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag :type="row.step === 1 ? 'danger' : 'success'">{{ row.step === 1 ? '待上架' : '已上架' }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column align="left" label="位置坐标" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.basic && row.basic.lat }}
        </template>
      </el-table-column> -->
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" @click="editActivity(row)">修改</el-button>
          <el-button type="text" @click="handleEdit(row)">{{row.step === 1 ? '上架' : '下架'}}</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { getProvinceList, delProvince, editProvince } from '@/api/apartment'
import Edit from './edit'
export default {
  name: 'Dynamic',
  components: { Edit },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword:''
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/apartment/province') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    editActivity(row) {
      this.$refs['edit'].showEdit(row)
    },
    async handleEdit(row) {
      const result = await editProvince({
        provinceId: row.provinceId,
        step: row.step === 1 ? 2 : 1
      })
      if (result) {
        this.$message.success(`${row.step === 1 ? '上架' : '下架'}成功`)
        this.fetchData()
      }
    },
    handleDelete(row) {
      if (row.provinceId) {
        this.$baseConfirm(`你确定要删除：${row.title}吗`, null, async () => {
          await delProvince({ provinceId: row.provinceId })
          this.$baseMessage(
            '删除成功',
            'success',
            false,
            'vab-hey-message-success'
          )
          await this.fetchData()
        })
      }
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await getProvinceList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
